import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IPointAllocation, defaultValue } from 'app/shared/model/point-allocation.model';

const initialState: EntityState<IPointAllocation> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  //rewardPoints:null,
};

const apiUrl = 'api/point-allocations';

const apiUrlPoints = '/api/allocateSignupPoints';
const apiUrlTotalPoints = 'api/totalPoints';
const apiUrlEarnedPoints = 'api/totalEarnedPoint';
const apiUrlPointsSummary = 'api/points/summary';

// Actions

export const getEntities = createAsyncThunk('pointAllocation/fetch_entity_list', async ({ page, size, sort }: IQueryParams) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}&` : '?'}cacheBuster=${new Date().getTime()}`;
  return axios.get<IPointAllocation[]>(requestUrl);
});

export const getEntity = createAsyncThunk(
  'pointAllocation/fetch_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<IPointAllocation>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const createEntity = createAsyncThunk(
  'pointAllocation/create_entity',
  async (entity: IPointAllocation, thunkAPI) => {
    const result = await axios.post<IPointAllocation>(apiUrl, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);
// export const createEntityIntialPoints = createAsyncThunk(
//   'pointAllocation/create_entity_inital_points',
//   async (id: string | number) => {
//     const requestUrl = `${apiUrlPoints}/${id}`;
//     const result = await axios.post<IPointAllocation>(requestUrl);
//     //thunkAPI.dispatch(getEntities({}));
//     return result;
//   },
//   { serializeError: serializeAxiosError }
// );
export const createEntityIntialPoints = createAsyncThunk(
  'pointAllocation/create_entity_inital_points',
  async (id: string | number, thunkAPI) => {
    const result = await axios.post<IPointAllocation>(`${apiUrlPoints}/${id}`);
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);
export const getEntityTotalPoints = createAsyncThunk(
  'pointAllocation/fetch_entity_totalpoints',
  async () => {
    const requestUrl = `${apiUrlTotalPoints}`;
    return axios.get<IPointAllocation>(requestUrl);
    console.log(axios.get<IPointAllocation>(requestUrl));
  },
  { serializeError: serializeAxiosError }
);
export const getEntityEarnedPoints = createAsyncThunk(
  'pointAllocation/fetch_entity_earnedpoints',
  async () => {
    const requestUrl = `${apiUrlEarnedPoints}`;
    return axios.get<IPointAllocation>(requestUrl);
    // console.log(axios.get<IPointAllocation>(requestUrl));
  },
  { serializeError: serializeAxiosError }
);
export const getEntityPointsSummary = createAsyncThunk(
  'pointAllocation/fetch_entity_pointssummary',
  async (type: string) => {
    const requestUrl = `${apiUrlPointsSummary}/?type=${type}`;
    return axios.get<IPointAllocation>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);
export const updateEntity = createAsyncThunk(
  'pointAllocation/update_entity',
  async (entity: IPointAllocation, thunkAPI) => {
    const result = await axios.put<IPointAllocation>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const partialUpdateEntity = createAsyncThunk(
  'pointAllocation/partial_update_entity',
  async (entity: IPointAllocation, thunkAPI) => {
    const result = await axios.patch<IPointAllocation>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const deleteEntity = createAsyncThunk(
  'pointAllocation/delete_entity',
  async (id: string | number, thunkAPI) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete<IPointAllocation>(requestUrl);
    thunkAPI.dispatch(getEntities({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);

// slice

export const PointAllocationSlice = createEntitySlice({
  name: 'pointAllocation',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(getEntityTotalPoints.fulfilled, (state, action) => {
        state.loading = false;
        state.entity['totalpoints'] = action.payload.data;
      })
      .addCase(getEntityEarnedPoints.fulfilled, (state, action) => {
        state.loading = false;
        state.entity['earnedpoints'] = action.payload.data;
      })
      .addCase(getEntityPointsSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(deleteEntity.fulfilled, state => {
        state.updating = false;
        state.updateSuccess = true;
        state.entity = {};
      })
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data,
          totalItems: parseInt(headers['x-total-count'], 10),
        };
      })
      .addMatcher(isFulfilled(createEntity, createEntityIntialPoints, updateEntity, partialUpdateEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getEntities, getEntity, getEntityTotalPoints, getEntityEarnedPoints, getEntityPointsSummary), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(createEntity, createEntityIntialPoints, updateEntity, partialUpdateEntity, deleteEntity), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = PointAllocationSlice.actions;

// Reducer
export default PointAllocationSlice.reducer;
